<template>
  <v-dialog v-model="dialog" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" max-width="800px">
    <v-card>
      <v-card-title class="pa-4 d-flex justify-space-between">
        <div class="d-flex align-center">
          <app-icon class="mr-2" size="50">wand_stars</app-icon>
          Editar com IA
        </div>
        <div>
          <v-btn @click="dialog = false" class="rounded-xl" icon>
            <app-icon size="18">close</app-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4 scroll">
        <v-row>
          <v-col>
            <v-card color="#ece9fb" class="elevation-0">
              <v-card-text class="pa-4">

                <div class="tex">
                  <template v-for="value in inputText">
                    <div>{{ value }}</div>
                  </template>
                </div>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-if="emptyState" class="d-flex flex-column align-center justify-center text-center"
              style="min-height: 250px;">
              <app-icon class="text-medium-emphasis mb-2" size="65">chat_bubble</app-icon>
              <h3 class="mt-5 mb-2 font-weight-regular">Peça à IA para gerar um novo texto</h3>
              <p class="text-medium-emphasis">Selecione uma das sugestões abaixo ou digite uma instrução.</p>
            </div>
            <div v-else class="d-flex" style="min-height: 250px;">
              <div class="mr-4">
                <v-avatar size="36" color="primary">
                  <app-icon size="18" color="white">wand_stars</app-icon>
                </v-avatar>
              </div>
              <div>
                <div class="mb-2">
                  <div v-if="generatedText" v-html="getContent(generatedText)"></div>

                  <!-- <span v-if="generatedText">{{ generatedText }}</span> -->
                  <span v-else class="text-medium-emphasis">Gerando texto...</span>
                </div>
                <div v-if="!loading">
                  <v-btn class="mr-2" small outlined @click="dialog = false">
                    <app-icon class="mr-2" size="18">thumb_down</app-icon>
                    Não gostei
                  </v-btn>
                  <v-btn small color="primary" outlined @click="handleAccept">
                    <app-icon class="mr-2" size="18">thumb_up</app-icon>
                    Aceitar
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex w-100 flex-column">
        <div class="d-flex w-100 flex-wrap pb-4">
          <v-chip v-for="suggestion in suggestions" :key="suggestion" @click="useSuggestion(suggestion)" class="mx-1">
            {{ suggestion }}
          </v-chip>
        </div>
        <div class="ai-input-container">

          <app-text-field v-model="form.instructions" :readonly="loading" placeholder="Digite uma mensagem..." outlined
            dense hide-details @keydown.enter="createText">
            <template v-slot:append>
              <v-btn icon small color="primary" :disabled="!hasInstructions" @click="createText" :loading="loading">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
          </app-text-field>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import markdownit from 'markdown-it'
export default {
  name: 'TextGenerationForm',
  props: [],
  data() {
    return {
      dialog: false,
      loading: false,
      emptyState: true,
      suggestions: [
        'Melhorar a escrita',
        'Corrigir Gramática',
        'Expandir o texto',
        'Resumir o texto',
      ],
      form: {
        inputText: 'Olá teste',
        instructions: null,
      },
      generatedText: null,
      rawGeneratedText: null
    }
  },
  computed: {
    inputText() {
      return this.getText(this.form.inputText)
    },
    hasInstructions() {
      return this.form.instructions && this.form.instructions.length > 0;
    },
  },

  methods: {
    getContent(text) {
      const md = markdownit()
      return md.render(text)
    },


    open(textValue, type) {
      this.generatedText = null;
      this.emptyState = true;
      this.dialog = true;
      this.form.instructions = null;
      this.form.inputText = textValue;
      this.form.type = type;
    },
    useSuggestion(suggestion) {
      this.form.instructions = suggestion;
      this.createText();
    },
    createText() {
      this.loading = true;
      this.emptyState = false;
      this.generatedText = null;
      this.$http.$post('ai-assistant/text-formatting', this.form)
        .then(async response => {
          await this.setGeneratedText(response.text);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async setGeneratedText(text) {

      this.rawGeneratedText = text

      let arr = this.getText(text)

      let newText = ''

      for (let i = 0; i < arr.length; i++) {



        newText += arr[i]
        newText += '\n\n'



        // this.generatedText = arr[i]
        // await new Promise((resolve) => setTimeout(resolve, 20));
      }


      // for (let i = 0; i <= text.length; i++) {
      //   this.generatedText = text.substring(0, i);
      //   await new Promise((resolve) => setTimeout(resolve, 0.5));
      // }
      this.generatedText = newText.trim()

    },

    getText(input) {
      const inputArray = Array.isArray(input) ? input : []



      if (this.form.type == 'anamnese') {
        const text = inputArray
          .filter(item => item.question_type === "open" && item.answer)
          .map(item => {
            let question = item.question.trim()

            if (!question.endsWith("?") && !question.endsWith(":")) {
              question += ":"
            }

            return `${question} ${item.answer}`
          })

        return text
      }

      const text = inputArray
        .filter(item => item.type === "question" && item.answer)
        .map(item => {
          let question = item.question.trim()

          if (!question.endsWith("?") && !question.endsWith(":")) {
            question += ":"
          }

          return `${question} ${item.answer}`
        })

      return text
    },
    handleAccept() {
      this.$emit('store', this.rawGeneratedText);
      this.dialog = false;
    },

  }
}
</script>

<style scoped>
.scroll {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #e4e4e4 transparent;
}

.ai-input-container {
  /* position: fixed; */
  /* bottom: 5%;
  left: 50%; */
  /* transform: translateX(-50%); */
  width: 100%;
  /* max-width: 1000px; */
  background-color: white;
  padding: 10px;
}
</style>